import { useRecoilValue } from "recoil";
import { patientAtom } from "recoil/patientAtom";
import useOpenTask from "./useOpenTask";

export default function useOpenMeditationRecord(
  meditationRecordKey?: string,
  isOldVersion?: boolean
) {
  const patientState = useRecoilValue(patientAtom);
  const taskId = "5-7-T";
  const taskKey = `${taskId}:${patientState?.patientId}`;

  const openTask = useOpenTask(taskKey, undefined, meditationRecordKey);

  function addToTabAndOpen() {
    openTask();
  }

  return addToTabAndOpen;
}